import React, {Component} from "react";

class Services extends Component{
    render(){
        return(
            <div>
                Service
            </div>
        )
    }
}

export default Services